module.exports = __webpack_public_path__ + "img/p8-p1-bg.3835f030.jpg";